import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
    itemsAddedDialogAction,
    ItemsAddedDialogState,
} from '../../redux/slices/itemsAddedDialogSlice';

const useItemsAddedDialog = () => {
    const state: ItemsAddedDialogState = useAppSelector(
        (state) => state.itemsAddedDialog
    );
    const dispatch = useAppDispatch();

    const showDialog = (
        open: boolean,
        productsAdded: 'all' | 'none' | 'partially'
    ) => {
        dispatch(
            itemsAddedDialogAction.openDialog({
                open: open,
                productsAdded: productsAdded,
            })
        );
    };

    const setDialog = (
        translatePrefix: string,
        translateNS: string,
        handleGoToCart?: () => void
    ) => {
        dispatch(
            itemsAddedDialogAction.setDialog({
                translateKeyPrefix: translatePrefix,
                translateNS: translateNS,
                handleGoToCart: handleGoToCart,
            })
        );
    };

    const closeDialog = () => {
        dispatch(itemsAddedDialogAction.closeDialog());
    };

    return { ...state, showDialog, closeDialog, setDialog };
};

export default useItemsAddedDialog;
